const textFieldForgotPassword = {
  email: 'Email'
};

export default textFieldForgotPassword;
